<template>
	<!--sms-->
	<div class="edit" @click.self="close()" v-if='isShowDiv'>
		<div class="edit-con">
			<div class="edit-top">Call remark<a @click="close" /></div>
			<div class="content">
				<van-radio-group v-model="collectLogId" @change="changeRadio">
				  <van-radio :name="item.logId" v-for="item in collectionLogTypeList">{{item.logTypeEn}}</van-radio>
				</van-radio-group>
				
				<textarea v-model.trim="remark" placeholder="enter Calling remark" />
				<div class="btn-wrap">
					<a class="send call" @click="call">Call</a>
					<a class="send" @click="send">Done</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import { RadioGroup, Radio } from 'vant';
	import 'vant/lib/radio/style';
	import 'vant/lib/radio-group/style';
	Vue.use(Radio);
	Vue.use(RadioGroup);
	export default {
		data() {
			return {
				isShowDiv:false,
				collectLogId:"",
				collectType:"",
				remark:"",
				collectionLogTypeList:[]
			}
		},
		props:{
			close:{
				type:Function
			},
			phoneItem:{
				type:Object,
				default:()=>{}
			}
		},
		metaInfo: {
			title: 'Home'
		},
		created() {
			this.getCollectionLogType()
		},
		computed:{
			showSms:{
				get(){
					
				},
				set(){
					
				}
			}
		},
		methods: {
			send(){
				let self = this;
				if(!this.collectLogId){
					self.UTILS.logStr("Please Select Calling result");
					return
				}
				let parmas = [{
					collectLogId:self.collectLogId,
					collectLogType: self.collectType,
					collectRemark: self.remark,
					collectMobile: self.phoneItem.collectMobile,
					concatName: self.phoneItem.concatName,
					concatType: self.phoneItem.concatType,
					orderId: self.phoneItem.orderId,
					relationShip: self.phoneItem.relationShip
				}]
				self.UTILS.axiosRequest('post', self.PATHS.pwalletPath +'/collection/collectionCommit', parmas,(res) => {
					self.UTILS.loadGif.hide();
					if (res.code == '0000') {
						self.UTILS.logStr(res.message || "Send success");
						self.close();
						self.$emit("updatePhoneRecord")
					} else {
						self.UTILS.logStr(res.message);
					}
				})
			},
			
			getCollectionLogType(){
				let self = this;
				self.UTILS.axiosRequest('post', self.PATHS.pwalletPath +'/collection/listCollectionLogType', {},(res) => {
					self.UTILS.loadGif.hide();
					if (res.code == '0000') {
						self.collectionLogTypeList = res?.data || [];
						self.isShowDiv = true;
					} else {
						self.UTILS.logStr(res.message);
						self.isShowDiv = true;
					}
				},1)
			},
			
			changeRadio(val){
				if(val){
					const item = this.collectionLogTypeList.find(ele => ele.logId == val);
					this.collectType = item?.logTypeEn
				}
			},
			
			call(){
				location.href = `tel:0${this.phoneItem.collectMobile}`
			}
		}
	}
</script>

<style scoped>
	.edit{z-index: 9;position: fixed;bottom: 0;left: 0;right: 0;width: 100%;height: 100%;background: rgba(0, 0, 0, 0.6);}
	.edit-con{ width: 6.74rem;background-color: #FFF; border-radius: 0.1rem; position: fixed; left: 50%; top: 50%; margin: -4.56rem 0 0 -3.37rem; overflow: hidden;}
	.edit-top{ height: 0.8rem; padding: 0 0.3rem; line-height: 0.8rem; text-align: left; font-size: 0.36rem; color: #FFF; background-color: #21D1CC;}
	.edit-top a{ width: 0.4rem; height: 0.4rem; background: url(./img/icon11.png) no-repeat center; background-size: cover; float: right; margin-top: 0.2rem;}
	.content{padding: 0.3rem;}
	.content .select-sms {padding: 0.2rem 0.3rem;display: flex;align-items: center;justify-content: space-between;border-radius: 0.1rem;border: 1px solid #000000;}
	.content .select-sms span{flex: 1;text-align: center;font-size: 0.30rem;color: #000000;}
	.content textarea{ width:100%; padding: 0.1rem; line-height: 0.36rem; font-size: 0.28rem; color: #000; border: 0.02rem solid #787676; border-radius: 0.1rem; resize: none; margin: 0.24rem auto 0 auto;}
	.content .btn-wrap{display: flex;align-items: center;justify-content: space-between;}
	.content .send{ width: 2rem; height: 0.8rem; line-height: 0.8rem; text-align: center; font-size: 0.36rem; color: #FFF; background-color: #21D1CC; border-radius: 0.1rem; display: block; margin: 0.7rem auto 0 auto;}	
	.content .call{background: #2196F3;}
	/deep/ .van-radio{align-items: flex-start;}
	/deep/ .van-radio__icon{font-size: 18px;}
</style>
